<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-card-title class="headline">
        <span>
          Case Details
        </span>
        <i class="mdi mdi-close close-btn" @click="handleClose" :disabled="loading"></i>
      </v-card-title>
    </v-card>
    <v-content>
      <div class="modal-body">
        <div class="case-details-container">
          <template v-for="(value, valueKey) in data">
            <template v-if="!Array.isArray(value)">
              <span :key="valueKey" class="capitalise" v-if="value">
                <b>{{ valueKey.toString().split('_').join(' ') }}:</b>
                <scraped-value-display :value="String(value)" />
              </span>
            </template>
          </template>
        </div>
        <div>
          <div v-for="(table, index) in formattedTables" :key="index" class="card">
            <div class="card-header">
              <h2>{{ table.tableName }}</h2>
            </div>
            <div class="card-table">
              <customTable :headers="table.headers" :items="table.data">
                <template v-for="header in table.headers" v-slot:[`item.${header.value}`]="{ value }">
                  <scraped-value-display :key="header.value" :value="String(value)" />
                </template>
              </customTable>
            </div>
          </div>
        </div>
      </div>
    </v-content>
  </v-dialog>
</template>

<script>
import customTable from '../components/commonComponents/customTable.vue'
import ScrapedValueDisplay from '@/components/commonComponents/scrappedValueDisplay.vue'
import { formatKeyToLabel } from '../utils'

export default {
  name: 'CaseDetailsModal',
  components: {
    customTable,
    ScrapedValueDisplay
  },
  props: {
    dialog: Boolean,
    data: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      formattedTables: []
    }
  },
  methods: {
    handleClose () {
      this.dialog = false
    },
    formatTablesData (data) {
      const result = []
      for (const [tableNameKey, value] of Object.entries(data)) {
        if (Array.isArray(value) && value.length > 0) {
          const allKeys = Object.keys(value[0])
          const headers = allKeys.map(key => ({
            text: formatKeyToLabel(key),
            value: key
          }))

          result.push({
            tableName: formatKeyToLabel(tableNameKey),
            headers,
            data: value
          })
        }
      }
      this.formattedTables = result
    }
  },
  watch: {
    dialog (newVal) {
      if (!newVal) {
        this.$emit('close')
      }
    },
    data: {
      immediate: true,
      handler (newVal) {
        this.formatTablesData(newVal)
      }
    }
  }
}
</script>
<style scoped>
.headline{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.close-btn{
  padding-inline: 5px;
  border-radius: 50%;
}

.close-btn:hover{
  cursor: pointer;
  background: rgb(var(--secondary-color));
}

::v-deep .v-dialog{
  max-width: 100% !important;
  overflow: hidden !important;
}

::v-deep .v-content{
  height: 90vh !important;
  padding:0px;
  background-color: white;
  overflow: hidden !important;
}

::v-deep .v-card{
  box-shadow: none !important;
  border-radius: 0 !important;
  border-bottom: 1px solid #e5e7eb;
}

.capitalise {
  text-transform: capitalize;
}

.modal-body {
  padding:12px 24px;
  overflow-y: auto;
  height: 92%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.case-details-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 12px;
  font-size: 16px;
}

.card {
  margin-bottom: 12px;
}

.card-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.card-table {
  margin-top: 12px;
  overflow-x: auto;
}
</style>
